import React from 'react'
import LoginScreen from '../../containers/Login/Login'
import { ToastContainer } from 'react-toastify'

const LoginPage = () => {
  return (
    <>
      <LoginScreen />
      <ToastContainer />
    </>
  )
}

export default LoginPage
